import {connect} from "react-redux";
import {withRouter} from "react-router";
import React from "react";
import GridBlock from "components/GridBlock";
import {Typography, withStyles} from "@material-ui/core";
import NoActiveApproval from "./NoActiveApproval";
import SelectApprovers from "./SelectApprovers";
import ApprovalDecision from "./ApprovalDecision";
import IconHelp from "@material-ui/icons/HelpOutline";
import Tr from "translations/Translations";
import ApprovalHistoryList from "./ApprovalHistoryList";
import {showApprovalDecisionSection, showSelectApproversSection} from "./lib/ApprovalAccessUtils";
import * as PropTypes from "prop-types";

const style = theme => ({
    root: {
        width: '100%'
    },
    hidden: {
        display: 'none'
    },
    icon: theme.components.icon,
    center: {
        textAlign: "center"
    },
    itemClassName: {
        width: '100%'
    }
})

function Approval(
    {
        approvalObjectName,
        approvalSection,
        uncompletedApprovalObjectSections,
        approval,
        approvalHistoryList,
        loggedUser,
        startApproval,
        sendToApproval,
        resetApproval,
        stopApproval,
        sendDecision,
        loadApprovalHistory,
        getAvailableApprovers,
        addApprovers,
        deleteApprover,
        working,
        classes
    }) {

    const currentStage = !!approval ? approval.stages.find(s => s.status < 3) : null;

    const showNoApproval = !approval;
    const showSelectApprovers = showSelectApproversSection(approval, currentStage);
    const showApprovalDecisions = showApprovalDecisionSection(approval, currentStage, loggedUser);

    return (<div className={classes.root}>
        <GridBlock
            direction='column'
            alignItems='center'
            itemClassName={classes.itemClassName}
        >
            {showNoApproval && <NoActiveApproval approvalObjectName={approvalObjectName} approvalSection={approvalSection} startApproval={startApproval}
                                                 uncompletedApprovalObjectSections={uncompletedApprovalObjectSections} working={working} />}
            {showSelectApprovers && <SelectApprovers approval={approval} sendToApproval={sendToApproval} resetApproval={resetApproval} stopApproval={stopApproval} working={working} />}
            {showApprovalDecisions && <ApprovalDecision approval={approval} stage={currentStage} loggedUser={loggedUser} sendDecision={sendDecision} working={working} />}
            {!showNoApproval && !showSelectApprovers && !showApprovalDecisions &&
                <GridBlock
                    direction='column'
                    alignItems='center'
                >
                    <IconHelp className={classes.icon} color='primary'/>
                    <Typography variant='body1' className={classes.info}>{Tr(`${approvalObjectName}_preparing_approval_during`)}</Typography>
                </GridBlock>
            }
            {approvalHistoryList?.length > 0 && <ApprovalHistoryList approvalObjectName={approvalObjectName} approvalHistoryList={approvalHistoryList}
                                                    loadApprovalHistory={loadApprovalHistory} getAvailableApprovers={getAvailableApprovers} addApprovers={addApprovers} deleteApprover={deleteApprover} />}
        </GridBlock>
    </div>);
}

Approval.propTypes = {
    approvalObjectName: PropTypes.string,
    approvalSection: PropTypes.object,
    uncompletedApprovalObjectSections: PropTypes.array,
    approval: PropTypes.object,
    approvalHistoryList: PropTypes.array,
    loggedUser: PropTypes.object,
    startApproval: PropTypes.func,
    sendToApproval: PropTypes.func,
    resetApproval: PropTypes.func,
    stopApproval: PropTypes.func,
    sendDecision: PropTypes.func,
    working: PropTypes.bool,
    classes: PropTypes.any
}

export default connect((state) => ({
    loggedUser: state.resources.userData
}), {})(withStyles(style)(withRouter(Approval)));